import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import SbEditable from 'storyblok-react';

import StoryblokComponents from 'storyblok/';
import Container from 'components/Container';
import SectionHeadline from 'components/SectionHeadline';
import TextButton from 'components/TextButton';

const useStyles = makeStyles(theme => ({
	features: {
		backgroundColor: theme.palette.common.white,
		borderTop: ({ borderColor }) =>
			`${theme.sizes.topBorderWidth}px solid ${borderColor}`,
		boxShadow: theme.boxShadow,
		marginBottom: theme.sizes.componentSpacing,
		marginTop: theme.sizes.gutter,
		padding: theme.spacing(4, 0),
		transition: '0.3s ease-in-out margin-top',
		[theme.breakpoints.up('lg')]: {
			marginTop: ({ topMargin }) => `${topMargin}px`,
		},
	},
	headline: {
		margin: theme.spacing(2, 0),
	},
	feature: {
		padding: theme.spacing(2, 4),
	},
}));

const Features = ({ blok }) => {
	const classes = useStyles(blok);

	return (
		<SbEditable content={blok}>
			<section>
				<Container>
					<Grid
						item
						container
						direction="column"
						justify="center"
						alignItems="center"
						className={classes.features}
					>
						<SectionHeadline>{blok.headline}</SectionHeadline>
						<Grid item container justify="center">
							{blok.features.map(feature => (
								<Grid
									item
									className={classes.feature}
									key={feature._uid}
									xs={12}
									sm={6}
									md={3}
								>
									{React.createElement(
										StoryblokComponents(feature.component),
										{
											key: feature._uid,
											blok: feature,
										}
									)}
								</Grid>
							))}
						</Grid>
						{blok.linkTo && blok.linkTo.url && (
							<TextButton
								action={blok.linkTo.url}
								text={blok.linkText}
								title={`${blok.linkText} about ${blok.headline}`}
							/>
						)}
					</Grid>
				</Container>
			</section>
		</SbEditable>
	);
};

export default Features;
